var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col gap-6"
  }, [_c('div', {
    staticClass: "bg-white shadow-md rounded-md p-4"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_vm._m(0), _c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.downloadTemplateOrder'),
      "type": 'secondary',
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": _vm.downloadTemplate
    }
  })], 1)]), _c('div', {
    staticClass: "bg-white shadow-md rounded-md p-4 flex flex-col gap-4"
  }, [_c('div', {
    staticClass: "mb-4 text-left relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.createOrder.stepOne.senderAddress')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": _vm.$t('order.createOrder.stepOne.senderAddressPlaceholder')
    },
    on: {
      "input": function input($event) {
        return _vm.searchAddress($event, 'senderAddress');
      }
    },
    model: {
      value: _vm.senderAddressSearch,
      callback: function callback($$v) {
        _vm.senderAddressSearch = $$v;
      },
      expression: "senderAddressSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching['senderAddress'] ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion['senderAddress'] ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.addresses ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll shadow-base"
  }, _vm._l(_vm.addresses, function (address, index) {
    return _c('li', {
      key: 'address-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300 ",
      on: {
        "click": function click($event) {
          return _vm.selectAddress(address, 'senderAddress');
        }
      }
    }, [_vm._v(" " + _vm._s(address.location_label) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.createOrder.stepOne.dataNotFound')) + " ")])]) : _vm._e()])], 1)]), _c('div', {
    staticClass: "w-full mx-auto"
  }, [_c('label', {
    staticClass: "flex flex-col items-center justify-center w-full h-40 border-2 border-dashed rounded-xl cursor-pointer transition",
    class: [_vm.senderAddressSearch ? 'border-gray-300 bg-gray-50 hover:bg-gray-100 cursor-pointer' : 'border-red-400 bg-gray-100 cursor-not-allowed opacity-50'],
    attrs: {
      "for": "file-upload"
    }
  }, [_c('div', {
    staticClass: "flex flex-col items-center justify-center pt-5 pb-6"
  }, [!_vm.uploadedFile ? _c('svg', {
    staticClass: "w-12 h-12 mb-3 text-gray-500",
    attrs: {
      "fill": "currentColor",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 3a2 2 0 012-2h3a1 1 0 110 2H5v14h10V3h-3a1 1 0 110-2h3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V3z"
    }
  }), _c('path', {
    attrs: {
      "d": "M9 7a1 1 0 112 0v5.586l1.293-1.293a1 1 0 \n           111.414 1.414l-3 3a1 \n           1 0 01-1.414 0l-3-3a1 \n           1 0 111.414-1.414L9 12.586V7z"
    }
  })]) : _vm._e(), _vm.uploadedFile ? [_c('p', {
    staticClass: "text-lg font-semibold text-gray-700"
  }, [_vm._v("📂 " + _vm._s(_vm.uploadedFile.name))]), _c('p', {
    staticClass: "text-xs text-gray-500 mt-1"
  }, [_vm._v("Ukuran: " + _vm._s((_vm.uploadedFile.size / 1024).toFixed(2)) + " KB")])] : [_c('p', {
    staticClass: "text-lg font-semibold text-gray-700"
  }, [_vm._v("Unggah File Disini")]), _vm._m(1), _c('p', {
    staticClass: "text-xs text-gray-400 mt-1"
  }, [_vm._v("Format: XLSX, Ukuran Maksimum: 10 MB")]), !_vm.senderAddressSearch ? _c('p', {
    staticClass: "text-xs text-red-500 mt-2"
  }, [_vm._v(" *Harap isi Alamat Pengirim terlebih dahulu ")]) : _vm._e()]], 2), _c('input', {
    ref: "fileUpload",
    staticClass: "hidden",
    attrs: {
      "id": "file-upload",
      "type": "file",
      "disabled": !_vm.senderAddressSearch
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _c('Button', {
    attrs: {
      "buttonText": _vm.uploadIsLoading ? 'Uploading...' : 'Upload File',
      "type": "primary",
      "disabled": !_vm.senderAddressSearch || _vm.uploadIsLoading,
      "isLoading": _vm.uploadIsLoading
    },
    on: {
      "action": _vm.submitFile
    }
  })], 1), !_vm.uploadIsLoading ? _c('div', {
    staticClass: "bg-white shadow-md"
  }, [_c('div', {
    staticClass: "p-4 "
  }, [_vm.filteredData.length > 0 ? _c('Button', {
    attrs: {
      "buttonText": "Create Order",
      "type": "primary",
      "disabled": _vm.hasErrors
    },
    on: {
      "action": _vm.submitMultipleOrder
    }
  }) : _vm._e()], 1), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {}, _vm._l(_vm.filteredData, function (tempOrder) {
    return _c('div', {
      key: tempOrder.id
    }, [_c('UploadOrderCard', {
      attrs: {
        "data": tempOrder
      }
    })], 1);
  }), 0) : _c('div', {
    staticClass: "py-10 text-center"
  }, [_vm._v(_vm._s(_vm.$t('order.dataNotFound')))])]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("Template Upload")]), _c('p', {
    staticClass: "text-xs"
  }, [_vm._v("Mohon gunakan template yang sudah disediakan untuk upload paket.")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v(" Letakkan file kamu di sini atau "), _c('span', {
    staticClass: "text-gray-600 font-medium underline"
  }, [_vm._v("pilih file")])]);
}]

export { render, staticRenderFns }